import React from "react";
import { useSelector } from "react-redux";
import BillDetails from "./BillDetails";
import CartItem from "./CartItem";
import Navbar from "./Navbar";

const Cart = () => {
 const allCart = useSelector((state) => state.cart);

 return (
  <div>
   {/* <!-- Navbar --> */}
   <Navbar />
   {/* <!-- Navbar ends --> */}
   <main className="py-16">
    <div className="container 2xl:px-8 px-2 mx-auto">
     <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
     <div className="cartListContainer">
      <div className="space-y-6">
       {/* <!-- Cart Item --> */}
       {allCart?.map((item) => (
        <CartItem key={item?.id} details={item} />
       ))}

       {/* <!-- Cart Items Ends --> */}
      </div>

      {/* <!-- Bill Details --> */}
      <div>
       <BillDetails />
      </div>
     </div>
    </div>
   </main>
  </div>
 );
};

export default Cart;
